<app-layout-menu-bar fixed="true"></app-layout-menu-bar>
<router-outlet></router-outlet>
<app-layout-footer></app-layout-footer>
